<template>
  <div class="navigation-bar-config">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="navigation-bar-config-main">
      <div class="navigation-bar-config-main-navigation-bar">
        <div class="navigation-bar-config-main-title-line">
          <div class="navigation-bar-config-main-title-line-left">导航栏管理</div>
          <div class="navigation-bar-config-main-title-line-right">
            <button-confirm value="自定义导航栏" @confirm="homeDialogVisible = true" />
          </div>
        </div>
        <div class="navigation-bar-config-main-navigation-bar-info">
          <div v-for="nav in homeChooseList" class="navigation-bar-config-main-navigation-bar-info-item">
            <img :src="nav.icon" alt="" class="navigation-bar-config-main-navigation-bar-info-item-img">
            <div class="navigation-bar-config-main-navigation-bar-info-item-text">{{nav.name}}</div>
          </div>
        </div>
      </div>

      <div class="navigation-bar-config-main-more-nav">
        <div class="navigation-bar-config-main-title-line">
          <div class="navigation-bar-config-main-title-line-left">功能栏管理</div>
          <div class="navigation-bar-config-main-title-line-right">
            <button-confirm value="修改" @confirm="changeStatus = true" v-if="!changeStatus" />
            <button-confirm value="保存" style="margin-right: 20px" v-if="changeStatus" @confirm="confirm" />
            <button-cancel v-if="changeStatus" @cancel="cancel" />
          </div>
        </div>
        <div style="display: flex;justify-content: flex-start;margin: 20px 0 30px 0;padding: 0 20px;">
          <i class="el-icon-info" style="font-size: 20px;color: #00a0e6;margin-right: 5px;"></i>
          <span>点击右侧修改按钮可编辑功能栏模块，图表点亮时即显示此模块，模块可拖动排序</span>
        </div>
        <div class="navigation-bar-config-main-more-nav-info">
          <div class="navigation-bar-config-main-more-nav-info-box">
            <div class="navigation-bar-config-main-more-nav-info-box-title">信息服务</div>
            <draggable element="div" :list="informationServiceList" class="navigation-bar-config-main-more-nav-info-box-line" :disabled="!changeStatus">
              <div v-for="(item, index) in informationServiceList" :key="item.name" @click="changeServiceChoose('informationServiceList', index)">
                <div v-if="item.choose" class="navigation-bar-config-main-more-nav-info-box-line-item">
                  <img :src="item.icon" alt="" class="navigation-bar-config-main-more-nav-info-box-line-item-img">
                  <div class="navigation-bar-config-main-more-nav-info-box-line-item-text">{{item.name}}</div>
                </div>
                <div v-if="!item.choose" class="navigation-bar-config-main-more-nav-info-box-line-item">
                  <img :src="item.icon" alt="" class="navigation-bar-config-main-more-nav-info-box-line-item-img-gra" >
                  <div class="navigation-bar-config-main-more-nav-info-box-line-item-text" style="color:#cccccc;">{{item.name}}</div>
                </div>
              </div>
            </draggable>
          </div>
<!--          <div class="navigation-bar-config-main-more-nav-info-box">
            <div class="navigation-bar-config-main-more-nav-info-box-title">招商租赁</div>
            <draggable element="div" :list="investmentLeasingList" class="navigation-bar-config-main-more-nav-info-box-line" :disabled="!changeStatus">
              <div v-for="(item, index) in investmentLeasingList" :key="item.name" @click="changeServiceChoose('investmentLeasingList', index)">
                <div v-if="item.choose" class="navigation-bar-config-main-more-nav-info-box-line-item">
                  <img :src="item.icon" alt="" class="navigation-bar-config-main-more-nav-info-box-line-item-img">
                  <div class="navigation-bar-config-main-more-nav-info-box-line-item-text">{{item.name}}</div>
                </div>
                <div v-if="!item.choose" class="navigation-bar-config-main-more-nav-info-box-line-item">
                  <img :src="item.icon" alt="" class="navigation-bar-config-main-more-nav-info-box-line-item-img-gra" >
                  <div class="navigation-bar-config-main-more-nav-info-box-line-item-text" style="color:#cccccc;">{{item.name}}</div>
                </div>
              </div>
            </draggable>
          </div>-->
          <div class="navigation-bar-config-main-more-nav-info-box">
            <div class="navigation-bar-config-main-more-nav-info-box-title">公寓服务</div>
            <draggable element="div" :list="parkServiceList" class="navigation-bar-config-main-more-nav-info-box-line" :disabled="!changeStatus">
              <div v-for="(item, index) in parkServiceList" :key="item.name" @click="changeServiceChoose('parkServiceList', index)">
                <div v-if="item.choose" class="navigation-bar-config-main-more-nav-info-box-line-item">
                  <img :src="item.icon" alt="" class="navigation-bar-config-main-more-nav-info-box-line-item-img">
                  <div class="navigation-bar-config-main-more-nav-info-box-line-item-text">{{item.name}}</div>
                </div>
                <div v-if="!item.choose" class="navigation-bar-config-main-more-nav-info-box-line-item">
                  <img :src="item.icon" alt="" class="navigation-bar-config-main-more-nav-info-box-line-item-img-gra" >
                  <div class="navigation-bar-config-main-more-nav-info-box-line-item-text" style="color:#cccccc;">{{item.name}}</div>
                </div>
              </div>
            </draggable>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="自定义导航栏" :visible.sync="homeDialogVisible" width="700px">
      <div style="display: flex;justify-content: flex-start;margin: 20px 0 30px 0;padding: 0 20px;">
        <i class="el-icon-info" style="font-size: 20px;color: #00a0e6;margin-right: 5px;"></i>
        <span>可选项可以直接拖入已配置中，小程序首页将显示已配置的导航栏</span>
      </div>
      <div class="home-dialog-visible-box">
        <div class="home-dialog-visible-item" style="border-bottom: 1px solid #eeeeee;">
          <div class="navigation-bar-config-main-more-nav-info-box-title">已配置</div>
          <draggable element="div" :list="homeChooseList" class="home-dialog-visible-item-line" group="home" @change="homeChoose" @end="homeMoveEnd">
            <div v-for="item in homeChooseList" class="home-dialog-visible-item-line-item" :key="item.name" >
              <img :src="item.icon" alt="" class="home-dialog-visible-item-line-item-img" >
              <div class="home-dialog-visible-item-line-item-text" style="color:#cccccc;">{{item.name}}</div>
            </div>
          </draggable>
        </div>
        <div class="home-dialog-visible-item">
          <div class="navigation-bar-config-main-more-nav-info-box-title">可选项</div>
          <draggable element="div" :list="homeCanChooseList" class="home-dialog-visible-item-line" group="home" @change="homeChoose" @end="homeMoveEnd">
            <div v-for="item in homeCanChooseList" class="home-dialog-visible-item-line-item" :key="item.name" >
              <img :src="item.icon" alt="" class="home-dialog-visible-item-line-item-img" >
              <div class="home-dialog-visible-item-line-item-text" style="color:#cccccc;">{{item.name}}</div>
            </div>
          </draggable>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <button-cancel @cancel="cancel" />
        <button-confirm value="保存" @confirm="confirm" />
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
  import draggable from 'vuedraggable'
  import ButtonConfirm from '../../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../../components/Button/ButtonCancel'
  import {api} from '../../../api/ConfigManagement'
  import {errorHandler} from '../../../../utils/errorHandler'
  import {nError, nSuccess} from '../../../../utils/notice'
  import {iconListChoose} from "../../../../utils/icon";

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      Breadcrumb,
      draggable
    },
    name: 'navigation-bar-config',
    data () {
      return {
        breadcrumb: [{
          value: '资源中心',
          name: 'yq-information'
        }, {
          value: '配置管理'
        }],
        homeDialogVisible: false,
        changeStatus: false,
        configData: {},

        functionList: [
          {icon: iconListChoose('公寓介绍'), name: '公寓介绍'},
          {icon: iconListChoose('公寓公告'), name: '公寓公告'},
          {icon: iconListChoose('公寓咨询'), name: '公寓咨询'},

          {icon: iconListChoose('申请入住'), name: '申请入住'},
          {icon: iconListChoose('租期查询'), name: '租期查询'},
          {icon: iconListChoose('公寓缴费'), name: '公寓缴费'},
          {icon: iconListChoose('电费充值'), name: '电费充值'},
          {icon: iconListChoose('能耗计量'), name: '能耗计量'},

          {icon: iconListChoose('人员管理'), name: '人员管理'},
          {icon: iconListChoose('停车缴费'), name: '停车缴费'},
          {icon: iconListChoose('远程开门'), name: '远程开门'},
          {icon: iconListChoose('物业报修'), name: '物业报修'},
          {icon: iconListChoose('投诉建议'), name: '投诉建议'},
          {icon: iconListChoose('扫码抄表'), name: '扫码抄表'},
          {icon: iconListChoose('电子开票'), name: '电子开票'},
        ],

        homeAllList: [
          {icon: iconListChoose('公寓介绍'), name: '公寓介绍', choose: false},
          {icon: iconListChoose('公寓公告'), name: '公寓公告', choose: false},
          // {icon: iconListChoose('公寓咨询'), name: '公寓咨询', choose: false},
          {icon: iconListChoose('申请入住'), name: '申请入住', choose: false},
          {icon: iconListChoose('租期查询'), name: '租期查询', choose: false},
          {icon: iconListChoose('公寓缴费'), name: '公寓缴费', choose: false},
          {icon: iconListChoose('电费充值'), name: '电费充值', choose: false},
          {icon: iconListChoose('能耗计量'), name: '能耗计量', choose: false},
          {icon: iconListChoose('电子开票'), name: '电子开票', choose: false},
          {icon: iconListChoose('停车缴费'), name: '停车缴费', choose: false},
          {icon: iconListChoose('停车应急'), name: '停车应急', choose: false},
          {icon: iconListChoose('设备巡检'), name: '设备巡检', choose: false},
          {icon: iconListChoose('智慧巡更'), name: '智慧巡更', choose: false},
          {icon: iconListChoose('物业报修'), name: '物业报修', choose: false},
          {icon: iconListChoose('投诉建议'), name: '投诉建议', choose: false},
          {icon: iconListChoose('扫码抄表'), name: '扫码抄表', choose: false},
          {icon: iconListChoose('访客邀请'), name: '访客邀请', choose: false},
          {icon: iconListChoose('访客登记'), name: '访客登记', choose: false},
        ],

        homeChooseList: [],
        homeCanChooseList: [],
        homeDraggableDisabled: false,

        // 信息服务
        informationServiceList: [
          {icon: iconListChoose('公寓介绍'), name: '公寓介绍', choose: false},
          {icon: iconListChoose('公寓公告'), name: '公寓公告', choose: false},
          // {icon: iconListChoose('公寓咨询'), name: '公寓咨询', choose: false},
        ],

        // 招商租赁
        investmentLeasingList: [
          {icon: iconListChoose('申请入住'), name: '申请入住', choose: false},
          {icon: iconListChoose('租期查询'), name: '租期查询', choose: false},
          {icon: iconListChoose('公寓缴费'), name: '公寓缴费', choose: false},
          {icon: iconListChoose('电费充值'), name: '电费充值', choose: false},
          {icon: iconListChoose('能耗计量'), name: '能耗计量', choose: false},
          {icon: iconListChoose('电子开票'), name: '电子开票', choose: false}
        ],

        // 公寓服务
        parkServiceList: [
          {icon: iconListChoose('申请入住'), name: '申请入住', choose: false},
          {icon: iconListChoose('租期查询'), name: '租期查询', choose: false},
          {icon: iconListChoose('公寓缴费'), name: '公寓缴费', choose: false},
          {icon: iconListChoose('电费充值'), name: '电费充值', choose: false},
          {icon: iconListChoose('能耗计量'), name: '能耗计量', choose: false},
          {icon: iconListChoose('电子开票'), name: '电子开票', choose: false},
          {icon: iconListChoose('停车缴费'), name: '停车缴费', choose: false},
          {icon: iconListChoose('停车应急'), name: '停车应急', choose: false},
          {icon: iconListChoose('设备巡检'), name: '设备巡检', choose: false},
          {icon: iconListChoose('智慧巡更'), name: '智慧巡更', choose: false},
          {icon: iconListChoose('物业报修'), name: '物业报修', choose: false},
          {icon: iconListChoose('投诉建议'), name: '投诉建议', choose: false},
          {icon: iconListChoose('扫码抄表'), name: '扫码抄表', choose: false},
          {icon: iconListChoose('访客邀请'), name: '访客邀请', choose: false},
          {icon: iconListChoose('访客登记'), name: '访客登记', choose: false},
        ],

      }
    },
    created () {

      this.getAppletShowConfig()
    },
    methods: {
      add: function() {
        this.list.push({ name: "Juan" });
      },
      replace: function() {
        this.list = [{ name: "Edgard" }];
      },
      clone: function(el) {
        return {
          name: el.name + " cloned"
        };
      },
      homeChoose (e) {
        console.log(e)
      },
      homeMoveStart () {
        this.homeDraggableDisabled = false
      },
      homeMoveEnd () {
        if (this.homeChooseList.length > 8) {
          this.homeDraggableDisabled = true
        } else {
          this.homeDraggableDisabled = false
        }
      },

      // 服务项选择
      changeServiceChoose (str, index) {
        if (this.changeStatus) {
          this[str][index].choose = !this[str][index].choose
        } else {
         nError('请先点击上方修改按钮')
        }
      },

      getAppletShowConfig () {
        this.$axios.get(api.getAppletShowConfig, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              this.configData = data
              if (data.home) {
                let homeArr = data.home.split(',')
                this.homeChooseList = []
                homeArr.map(v => {
                  this.homeAllList.map(homeItem => {
                    if (homeItem.name === v) {
                      this.homeChooseList.push(homeItem)
                    }
                  })
                })
              }
              if (data.infoService) {
                let infoServiceArr = data.infoService.split(',')
                infoServiceArr.map((v, i) => {
                  this.informationServiceList.map((informationItem, informationIndex) => {
                    if (informationItem.name === v) {
                      informationItem.choose = true
                      if (this.informationServiceList[i] && this.informationServiceList[i].choose === false) {
                        this.informationServiceList[i] = this.informationServiceList.splice(informationIndex, 1, this.informationServiceList[i])[0];
                      }
                    }
                  })
                })
              }
              if (data.leaseService) {
                let leaseServiceArr = data.leaseService.split(',')
                leaseServiceArr.map((v, i) => {
                  this.investmentLeasingList.map((investmentLeasingItem, investmentLeasingIndex) => {
                    if (investmentLeasingItem.name === v) {
                      investmentLeasingItem.choose = true
                      if (this.investmentLeasingList[i] && this.investmentLeasingList[i].choose === false) {
                        this.investmentLeasingList[i] = this.investmentLeasingList.splice(investmentLeasingIndex, 1, this.investmentLeasingList[i])[0];
                      }
                    }
                  })
                })
              }
              if (data.parkService) {
                let leaseServiceArr = data.parkService.split(',')
                leaseServiceArr.map((v, i) => {
                  this.parkServiceList.map((parkServiceItem, parkServiceIndex) => {
                    if (parkServiceItem.name === v) {
                      parkServiceItem.choose = true
                      if (this.parkServiceList[i] && this.parkServiceList[i].choose === false) {
                        this.parkServiceList[i] = this.parkServiceList.splice(parkServiceIndex, 1, this.parkServiceList[i])[0];
                      }
                    }
                  })
                })
              }
              this.getHomeCanChooseList()
            }
          })
          // .catch(errorHandler('获取配置信息失败'))
      },

      getHomeCanChooseList () {
        this.homeCanChooseList = this.homeAllList.filter(v => {
          let isExistence = false
          this.homeChooseList.map(chooseItem => {
            if (v.name === chooseItem.name) {
              isExistence = true
            }
          })
          return !isExistence
        })
      },

      confirm () {
        let homeArr = []
        this.homeChooseList.map(v => {
          homeArr.push(v.name)
        })
        this.configData.home = homeArr.join(',')

        let infoServiceArr = []
        this.informationServiceList.map(v => {
          if (v.choose) {
            infoServiceArr.push(v.name)
          }
        })
        this.configData.infoService = infoServiceArr.join(',')

        let leaseServiceArr = []
        this.investmentLeasingList.map(v => {
          if (v.choose) {
            leaseServiceArr.push(v.name)
          }
        })
        this.configData.leaseService = leaseServiceArr.join(',')

        let parkServiceArr = []
        this.parkServiceList.map(v => {
          if (v.choose) {
            parkServiceArr.push(v.name)
          }
        })
        this.configData.parkService = parkServiceArr.join(',')
        // for (let i in this.configData) {
        //   if (this.configData[i].indexOf('人员认证') !== -1 && this.configData[i].indexOf('申请加入') === -1) {
        //     this.configData[i].unshift('申请加入,')
        //   }
        // }
        this.$axios.post(api.saveOrUpdateAppletShowConfig, this.configData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('保存成功')
              this.changeStatus = false
              this.getAppletShowConfig()
              this.homeDialogVisible = false
            }
          })
          .catch(errorHandler('保存失败'))
      },

      cancel () {
        this.informationServiceList = [
          {icon: iconListChoose('公寓介绍'), name: '公寓介绍', choose: false},
          {icon: iconListChoose('公寓公告'), name: '公寓公告', choose: false},
          // {icon: iconListChoose('公寓咨询'), name: '公寓咨询', choose: false},
        ]
        this.investmentLeasingList = [
          {icon: iconListChoose('申请入驻'), name: '申请入住', choose: false},
          {icon: iconListChoose('租期查询'), name: '租期查询', choose: false},
          {icon: iconListChoose('公寓缴费'), name: '公寓缴费', choose: false},
          {icon: iconListChoose('电费充值'), name: '电费充值', choose: false},
          {icon: iconListChoose('能耗计量'), name: '能耗计量', choose: false},
          {icon: iconListChoose('电子开票'), name: '电子开票', choose: false}
        ]

        this.parkServiceList = [
          {icon: iconListChoose('申请入住'), name: '申请入住', choose: false},
          {icon: iconListChoose('租期查询'), name: '租期查询', choose: false},
          {icon: iconListChoose('公寓缴费'), name: '公寓缴费', choose: false},
          {icon: iconListChoose('电费充值'), name: '电费充值', choose: false},
          {icon: iconListChoose('能耗计量'), name: '能耗计量', choose: false},
          {icon: iconListChoose('电子开票'), name: '电子开票', choose: false},
          {icon: iconListChoose('停车缴费'), name: '停车缴费', choose: false},
          {icon: iconListChoose('停车应急'), name: '停车应急', choose: false},
          {icon: iconListChoose('设备巡检'), name: '设备巡检', choose: false},
          {icon: iconListChoose('智慧巡更'), name: '智慧巡更', choose: false},
          {icon: iconListChoose('物业报修'), name: '物业报修', choose: false},
          {icon: iconListChoose('投诉建议'), name: '投诉建议', choose: false},
          {icon: iconListChoose('扫码抄表'), name: '扫码抄表', choose: false},
          {icon: iconListChoose('访客邀请'), name: '访客邀请', choose: false},
          {icon: iconListChoose('访客登记'), name: '访客登记', choose: false},
        ]
        this.homeChooseList = []
        this.homeCanChooseList = []
        this.changeStatus = false
        this.getAppletShowConfig()
        this.homeDialogVisible = false
      }
    }
  }
</script>

<style lang="less">
  .navigation-bar-config {
    font-family: Source Han Sans SC;
    .navigation-bar-config-main {
      margin: 20px 0 0 0;
      .navigation-bar-config-main-title-line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 41px;
        padding: 0 17px;
        background: #F2F8FF;
        .navigation-bar-config-main-title-line-left {
          height: 24px;
          font-size: 17px;
          font-weight: 500;
          line-height: 24px;
          color: #333333;
        }
      }
      .navigation-bar-config-main-navigation-bar {
        width: 100%;
        height: auto;
        min-height: 108px;
        background: #FFFFFF;
        border-radius: 7px;
        overflow: hidden;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        .navigation-bar-config-main-navigation-bar-info {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;
          .navigation-bar-config-main-navigation-bar-info-item {
            width: 80px;
            height: 80px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            .navigation-bar-config-main-navigation-bar-info-item-img {
              width: 32px;
              height: 32px;
            }
            .navigation-bar-config-main-navigation-bar-info-item-text {
              height: 17px;
              font-size: 12px;
              font-weight: 400;
              line-height: 17px;
              color: #333333;
            }
          }
        }
      }

      .navigation-bar-config-main-more-nav {
        width: 100%;
        height: auto;
        margin-top: 25px;
        min-height: 108px;
        background: #FFFFFF;
        border-radius: 7px;
        overflow: hidden;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        .navigation-bar-config-main-more-nav-info {
          .navigation-bar-config-main-more-nav-info-box {
            .navigation-bar-config-main-more-nav-info-box-title {
              text-align: left;
              height: 20px;
              font-size: 13px;
              font-weight: 500;
              line-height: 20px;
              color: #333333;
              padding: 0 20px;
              margin-top: 25px;
            }
            .navigation-bar-config-main-more-nav-info-box-line {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              flex-wrap: wrap;
              .navigation-bar-config-main-more-nav-info-box-line-item {
                cursor: pointer;
                width: 80px;
                height: 80px;
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;
                position: relative;
                .navigation-bar-config-main-more-nav-info-box-line-item-mask {
                  width: 32px;
                  height: 32px;
                }
                .navigation-bar-config-main-more-nav-info-box-line-item-img {
                  width: 32px;
                  height: 32px;
                }
                .navigation-bar-config-main-more-nav-info-box-line-item-img-gra {
                  width: 32px;
                  height: 32px;
                  filter: grayscale(1);
                }
                .navigation-bar-config-main-more-nav-info-box-line-item-text {
                  height: 17px;
                  font-size: 12px;
                  font-weight: 400;
                  line-height: 17px;
                  color: #333333;
                }
              }
            }
          }
        }
      }
    }


    .home-dialog-visible-box {
      .home-dialog-visible-item {
        width: 100%;
        margin-bottom: 20px;
        .navigation-bar-config-main-more-nav-info-box-title {
          text-align: left;
          height: 20px;
          font-size: 13px;
          font-weight: 500;
          line-height: 20px;
          color: #333333;
          padding: 0 20px;
        }
        .home-dialog-visible-item-line {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;
          .home-dialog-visible-item-line-item {
            cursor: pointer;
            width: 80px;
            height: 80px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            position: relative;
            .home-dialog-visible-item-line-item-img {
              width: 32px;
              height: 32px;
            }
            .home-dialog-visible-item-line-item-text {
              height: 17px;
              font-size: 12px;
              font-weight: 400;
              line-height: 17px;
              color: #333333;
            }
          }
        }
      }
    }
    /*.function-list {*/
      /*!*width: 50%;*!*/
      /*display: flex;*/
      /*justify-content: flex-start;*/
      /*!*flex-direction: column;*!*/
      /*overflow: auto;*/
      /*.function-item {*/
        /*display: flex;*/
        /*justify-content: flex-start;*/
        /*flex-direction: column;*/
        /*margin-right: 20px;*/
        /*padding: 20px;*/
        /*i {*/
          /*font-size: 24px;*/
        /*}*/

        /*span {*/
          /*width: 60px;*/
          /*font-size: 12px;*/
        /*}*/
      /*}*/
    /*}*/
  }
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/configManagement/NavigationBarConfig/NavigationBarConfig.vue